import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "description", "teamContainer", "tagsContainer" ]

  connect() {
    const firstTag = this.tagsContainerTarget.querySelector('.team-tag');

    if (firstTag) {
      firstTag.click();
    }
  }

  filterMembers(event) {
    event.preventDefault();
    const tag = event.currentTarget.dataset.tag;
    event.currentTarget.classList.add('team-tag--active');
    event.currentTarget.parentElement.querySelectorAll('.team-tag').forEach(tag => {
      if (tag !== event.currentTarget) {
        tag.classList.remove('team-tag--active');
      }
    });
    const description = event.currentTarget.dataset.description;
    this.descriptionTarget.textContent = description;
    Array.from(this.teamContainerTarget.children).forEach(member => {
      if (tag === '' || member.dataset.tags.includes(tag)) {
        member.style.display = '';
      } else {
        member.style.display = 'none';
      }
    });
  }
}
